import {
  createColumnHelper as createColumnHelperTanstack,
  type DisplayColumnDef,
  type RowData,
} from '@tanstack/react-table';
import { SpecialColumnsIds } from './SpecialColumns';

export const createColumnHelper = <TData extends RowData>() => {
  const helper = createColumnHelperTanstack<TData>();
  return {
    ...helper,
    actions: (
      options: Omit<
        DisplayColumnDef<TData>,
        'id' | 'enableResizing' | 'enableSorting' | 'enablePinning' | 'enableHiding'
      >,
    ) =>
      helper.display({
        ...options,
        id: SpecialColumnsIds.ACTIONS,
        enableResizing: false,
        enableSorting: false,
        enablePinning: false,
        enableHiding: false,
      }),
    state: (
      options: Omit<
        DisplayColumnDef<TData>,
        'id' | 'enableResizing' | 'enableSorting' | 'enablePinning' | 'enableHiding'
      >,
    ) =>
      helper.display({
        ...options,
        id: SpecialColumnsIds.STATE,
        enableResizing: false,
        enableSorting: false,
        enablePinning: false,
        enableHiding: false,
      }),
  };
};
